import { render, staticRenderFns } from "./ListaProdutosDialog.vue?vue&type=template&id=8cf05522&scoped=true"
import script from "./ListaProdutosDialog.vue?vue&type=script&lang=js"
export * from "./ListaProdutosDialog.vue?vue&type=script&lang=js"
import style0 from "./ListaProdutosDialog.vue?vue&type=style&index=0&id=8cf05522&prod&scoped=true&lang=css"
import style1 from "./ListaProdutosDialog.vue?vue&type=style&index=1&id=8cf05522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf05522",
  null
  
)

export default component.exports